import validatorResult from '@/directives/validator/common/result/validatorResult';

const isValid = (value, length) => value && value.length >= length;
export default (length, severity = 'danger') => (value) => validatorResult(
  isValid(value, length),
  {
    danger: `Värdet måste vara minst ${length} tecken långt`,
    warn: `Värdet bör vara minst ${length} tecken långt`,
  },
  severity,
);
